module.exports = __webpack_public_path__ + "img/aussie-rules-dark.380de59d.svg";